import PropTypes from 'prop-types'
import { styled } from '@mui/system'
import { useEffect, useState } from 'react'
import Sidebar from '../components/naviation/sidebar/Sidebar'
import { Divider } from '@mui/material'
import ModalCrearCopia from '../components/modals/ModalCrearCopia'
import { useLocation } from 'react-router-dom'
import { RouteNames } from 'models/routes'
import { isInScope } from 'common'
import HeaderAdapter from './header/HeaderAdapter'

const Main = styled('main')({
  display: 'flex',
  position: 'relative',
  width: '100%',
  flexGrow: 1,
  overflow: 'auto'
})

const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%'
})

interface LayoutProps {
  children: React.ReactNode
}

const scopes = {
  routes: [RouteNames.llistatOrgans, RouteNames.llistatPlantilles, RouteNames.home]
}

const Layout = ({ children }: LayoutProps) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [sidebarEnable, setSidebarEnable] = useState<boolean>(true)

  const location = useLocation()

  useEffect(() => {
    setSidebarEnable(isInScope(location.pathname as RouteNames, scopes))
    setModalOpen(false)
  }, [location.pathname, scopes])

  return (
    <>
      {location.pathname !== RouteNames.copiaCallback && <HeaderAdapter />}
      <Main>
        {sidebarEnable && (
          <>
            <Sidebar setModalOpen={setModalOpen} />
            <Divider orientation="vertical" style={{ opacity: '.3' }} />
            <ModalCrearCopia modalOpen={modalOpen} setModalOpen={setModalOpen} />
          </>
        )}
        <Content sx={{ overflow: 'auto' }}>{children}</Content>
      </Main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired
}

export default Layout
